
/**
 * DataHangar_mini.js
 */


class DataHangarMini {

	constructor( resultData ) {

		this._resultData = resultData;

		this._categMiniFactory = new CategMiniFactory(resultData, 3);

		//  base
		//
		this._nb3 = this._categMiniFactory.nb3;
		this._nb4 = this._categMiniFactory.nb4;
		this._resultMap = this._categMiniFactory.resultMap;

		this._nb = this._categMiniFactory.nb;


		// predict
		this._PRED_SIZE = [5, 10, 20, 50, 100, 200, 500, 1000, 2000, this._nb.length];

		this._PRED_RANGE = [ 5, 10, 20, 50 ];


	};

	get or34() {   return this._or34;   };

	get resultData() {   return this._resultData;   };

	//
	get nb() {   return this._nb;   };
	get nb3() { return this._nb3; };
	get nb4() { return this._nb4; };
	get resultMap() { return _resultMap; };

	get nbMini() { return this._categMiniFactory.nbMini; }

	get miniCategory() {   return this._categMiniFactory.miniCategory;   }


	getBooArray(rank, bit0_9, is) {
		return this._categMiniFactory.getBooArray(rank, bit0_9, is);
	};
	getBooArrayForList(objList) {
		let booArrayList = [];
		for(let i=0, n=objList.length; i<n; i++) {
			let booArray = this._categMiniFactory.getBooArray(objList[i].rank, objList[i].bit, objList[i].is);
			booArrayList.push( booArray );
		};
		return this.getBooArryJoin(booArrayList);
	};
	getBooArryJoin(booArrayList) {
		let resultBooArray = MyUtility.makeFillArray(booArrayList[0].length, true);
		for(let i=0, n=booArrayList.length; i<n; i++) {
			let booArray = booArrayList[i];
			for(let j=0, m=booArray.length; j<m; j++) {
				if( ! booArray[j] ) {   resultBooArray[j] = false;   };
			};
		};
		return resultBooArray;
	};

	getDefBooArray(categ, bit0_9, is) {
		return this._categMiniFactory.getDefBooArray(categ, bit0_9, is);
	};
	getDefBooArrayForList(objList) {
		let booArrayList = [];
		for(let i=0, n=objList.length; i<n; i++) {
			let booArray = this._categMiniFactory.getDefBooArray(objList[i].rank, objList[i].bit, objList[i].is);
			booArrayList.push( booArray );
		};
		return this.getBooArryJoin(booArrayList);
	};


	getPercent(rank, bit0_9, is) {
		return this._categMiniFactory.getPercent(categ, bit0_9, is);
	};


	getTotalResultList(objList) {
		return this._categMiniFactory.getResultNbListForList(objList);
	};



	//
	makePredictData(resultBooArray, defCount) {

		let resultMap = new Map();

		let percent = defCount/100;
		let predSize = this._PRED_SIZE;
		//  PRED_SIZE ごとの理論値
		let theoryVal = [];
		//  PRED_SIZE ごとの誤差理論値
		let errThVal = [];

		for(let i=0, n=predSize.length; i<n; i++) {
			theoryVal.push( predSize[i]*percent );
			errThVal.push( Math.sqrt(predSize[i])*percent );
		};

		//  PRED_SIZE ごとのカウント
		let resultCount = [];
		let count = 0,  predCt = 0;
		let itr = predSize[Symbol.iterator]();
		let itrD = itr.next();

		let predRange = this._PRED_RANGE;
		//  PRED_RANGE ごとのカウント配列格納Map
		let intervalMap = new Map();
		for(let i=0, n=predRange.length; i<n; i++) {   intervalMap.set(predRange[i], []);   };
		let intervalCt = [ 0, 0, 0, 0 ];

		for(let arr=resultBooArray, i=arr.length-1; i>=0; i--) {
			count++;
			if(arr[i]) {
				predCt++;
				for(let j=0, n=predRange.length; j<n; j++) {   intervalCt[j]++;   };
			};
			if(itrD.value===count) {
				resultCount.push(predCt);
				itrD = itr.next();
			};

			for(let j=0, n=predRange.length; j<n; j++) {

				if(count%predRange[j]===0)  {
					let arr = intervalMap.get(predRange[j])
					if(arr.length<20) {
						arr.push(intervalCt[j]);
					};
					intervalCt[j] = 0;
				};
			};
		};

		//  theoryPer と resultCount との差(Gap) の配列
		let thValCountGap = [];
		for(let i=0, n=theoryVal.length; i<n; i++) {
			thValCountGap.push( resultCount[i] - theoryVal[i] );
		};


		resultMap.set( 'theoryVal', theoryVal );
		resultMap.set( 'errThVal', errThVal );
		resultMap.set( 'resultCt', resultCount );
		resultMap.set( 'thValCountGap', thValCountGap );
		resultMap.set( 'intervalMap', intervalMap );

		resultMap.set('percent', defCount);

		return resultMap;
	};

};
